
    <div class="g-edit">
      <span class="btn btn-primary btn-xs" (click)="deleteClick.emit(state.currIndex)">
        <span class="fa fa-remove "></span>
      </span>
    </div>
  